module.exports = __webpack_public_path__ + "img/V42.9cd83763.jpg";